import React, { useState, useEffect } from 'react';
import BaseV2 from '../../layout/BaseV2';
import { useParams } from 'react-router-dom';
import WebCreateInspectionV2 from './webCreateInsV2';
import { get } from '../../../services/back.service';
import NotFoundInspect from '../../../pages/error/notFoundInspect';

export default function CreateInspectionV2() {
  const { editid } = useParams();
  const [id, setId] = useState(0);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const validInspection = async () => {
      try {
        const respoInfo = await get(`/peritaje/validinspection/${(editid || 0)}`, {});
        if (respoInfo.success) {
          setId(respoInfo.data.id);
        } else {
          setRedirect(true);
        }
      } catch (err) {
        console.error('Error validating inspection:', err);
        setRedirect(true);
      }
    };
    validInspection();
  }, [editid]);

  if (redirect) {
    return <NotFoundInspect />;
  }

  return (
    <BaseV2>
      <WebCreateInspectionV2 editid={id} />
    </BaseV2>
  );
}
